'use client'

/**
 * Server bileşeninden import için ince client sınır.
 * clientOnlyDynamic yok — ekstra mount/istek ve yükseklik zıplaması üretmesin.
 */
export { default } from '@/components/WeatherMarketBar'
